import Head from "components/Head"

import JobHeader from "components/jobs/JobHeader"
import JobIntro from "components/jobs/JobIntro"

import positions from "components/jobs/positions.json"
import Breadcrumbs from "components/jobs/Breadcrumbs"
import Link from "next/link"

const position = positions.find((position) => position.url === "designer")

const pages = [
  { name: "Careers", href: "/careers", current: false },
  {
    name: "Designer",
    href: "/careers/designer",
    current: true,
  },
]

export default function IndexPage() {
  if (!position) {
    return null
  }
  return (
    <div className="h-full">
      <Head share_img="https://paragraph.xyz/featureline/success.png" />

      <main className="h-full">
        <JobHeader />
        <div className="h-full py-12">
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <Breadcrumbs pages={pages} />

            <main className="max-w-2xl lg:max-w-6xl mx-auto px-6">
              <article className="border-gray-100 grid pt-12 pb-20 lg:grid-cols-3 lg:gap-16">
                <div className="hidden lg:block">
                  <aside className="sticky top-6 rounded-lg bg-gray-50 p-8">
                    <div className="-my-4 divide-y-2 divide-gray-100">
                      <dl className="divide-y-2 divide-gray-100">
                        <div className="py-4">
                          <dt className="sr-only">Employment type</dt>
                          <dl className="flex items-start space-x-2 text-sm leading-5">
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="h-5 w-5 text-gray-400"
                            >
                              <path
                                fillRule="evenodd"
                                d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                                clipRule="evenodd"
                              ></path>
                              <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15a24.98 24.98 0 01-8-1.308z"></path>
                            </svg>
                            <span className="text-gray-800">Full-time</span>
                          </dl>
                        </div>
                        <div className="py-4">
                          <dt className="sr-only">Location</dt>
                          <dl className="flex items-start space-x-2 text-sm leading-5">
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="h-5 w-5 text-gray-400"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                            <div>
                              <div className="text-gray-800">Remote</div>
                              <div className="text-gray-500">
                                North American time zones
                              </div>
                            </div>
                          </dl>
                        </div>
                        {/*
                        <div className="py-4">
                          <dt className="sr-only">Salary</dt>
                          <dl className="flex items-start space-x-2 text-sm leading-5">
                            <svg
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="h-5 w-5 text-gray-400"
                            >
                              <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"></path>
                              <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                            <div>
                              <div className="text-gray-800">
                                {position.salary} USD
                              </div>
                            </div>
                          </dl>
                        </div>
                        */}
                      </dl>
                      <div className="py-4">
                        <Link href="/careers/apply?role=Head of Growth">
                          <span className="cursor-pointer hover:bg-blue-300 inline-block rounded-md bg-blue-500 px-4 py-2.5 text-base leading-6 font-semibold text-white">
                            Apply for this job
                          </span>
                        </Link>
                      </div>
                    </div>
                  </aside>
                </div>
                <div className="col-span-2 space-y-12">
                  <div className="space-y-8">
                    <div className="space-y-2">
                      <h1 className="text-3xl leading-9 font-bold text-gray-900 sm:text-4xl sm:leading-10">
                        {position.title}
                      </h1>
                      <p className="text-lg leading-7 text-gray-500">
                        {position.subtitle}
                      </p>
                    </div>
                    <div className="flow-root lg:hidden">
                      <div className="-my-4">
                        <dl className="sm:grid sm:grid-cols-2">
                          <div className="py-4 border-b border-gray-100">
                            <dt className="sr-only">Employment type</dt>
                            <dl className="flex items-start space-x-2 text-sm leading-5">
                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="h-5 w-5 text-gray-400"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                                  clipRule="evenodd"
                                ></path>
                                <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15a24.98 24.98 0 01-8-1.308z"></path>
                              </svg>
                              <span className="text-gray-800">Full-time</span>
                            </dl>
                          </div>
                          <div className="py-4 border-b border-gray-100">
                            <dt className="sr-only">Location</dt>
                            <dl className="flex items-start space-x-2 text-sm leading-5">
                              <svg
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                className="h-5 w-5 text-gray-400"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                              <div>
                                <div className="text-gray-800">Remote</div>
                                <div className="text-gray-500">
                                  North American time zones
                                </div>
                              </div>
                            </dl>
                          </div>
                        </dl>
                      </div>
                    </div>
                  </div>
                  <div className="prose prose-blue">
                    <JobIntro />
                    <h2 id="about-the-job">About the job</h2>
                    <p>
                      We're seeking a talented and visionary Lead Designer to
                      spearhead all design and branding initiatives. This role
                      is pivotal in shaping the visual and interactive aspects
                      of our product, ensuring a cohesive and appealing user
                      experience for both creators & their audience.
                    </p>
                    <p>
                      We're a small team, so you'll be wearing lots of hats and
                      working closely with the product and engineering teams to
                      bring your designs to life.
                    </p>
                    <section>
                      <h3>Responsibilities</h3>
                      <ul>
                        <li>Develop comprehensive design strategies.</li>
                        <li>
                          Create and implement visually engaging design
                          solutions.
                        </li>
                        <li>Conduct user research and prototype testing.</li>
                        <li>Manage design guidelines and standards.</li>
                      </ul>
                    </section>
                    <section>
                      <h3>Qualifications</h3>
                      <ul>
                        <li>
                          Experience with Adobe Creative Suite, Sketch, or
                          Figma.
                        </li>
                        <li>
                          Strong portfolio showcasing digital design
                          competencies.
                        </li>
                        <li>
                          Excellent problem-solving and team management skills.
                        </li>

                        <li>Primarily live between GMT-8 and GMT-5.</li>
                      </ul>
                    </section>
                  </div>
                  <div>
                    <Link href="/careers/apply?role=Head of Growth">
                      <span className="cursor-pointer hover:bg-blue-300 inline-block rounded-md bg-blue-500 px-4 py-2.5 text-base leading-6 font-semibold text-white">
                        Apply for this job
                      </span>
                    </Link>
                  </div>
                </div>
              </article>
            </main>
          </div>
        </div>
      </main>

      <main className="max-w-3xl"></main>
    </div>
  )
}
